import {verifiedPreviewEmployees} from './VerifiedPreviewRoster';

// Public example capability cards are intentionally generic. Never bundle
// private employee profile instructions or owner-specific nickname metadata
// into an anonymous preview. Live owner skills are loaded after sign-in.
export const publicRoleSkillCatalog=verifiedPreviewEmployees.map(employee=>({
 roleKey:employee.roleKey,
 skills:[{
  id:'public-role-skill-'+employee.roleKey,
  name:employee.role+' Workflow',
  description:'Example capability for the '+employee.role.toLowerCase()+' role. Real employee skills and assignments are private.',
  steps:'Review the objective, identify required information and prepare a draft for the owner.',
  success:'A clear draft and documented next steps ready for owner review.'
 }]
}));
